const stadium_initial_value = {
  name: '',
  stadium_profile_pic: '',
  status: 'active',
  max_drink_quantity: 6,
  max_food_quantity: 10,
  max_banner_quantity: 6,
  max_recommend_quantity: 4,
  session_expire_hours: 6,
  enable_drink_quantity_control: false,
  enable_food_quantity_control: false,
  zones: [],
  administrators: [],
  super_administrators: [],
  riders: [],
  email_retention_days: 30,
  cms_settings: {
    pre_order: false,
  },
};

export { stadium_initial_value };
